import React from 'react';
import ServiceDetail from '../ServiceDetail';

// Dedicated page component for /services/rodent-control
// Renders the rodent-control service with hard-pinned slug.
const RodentControlPage = () => <ServiceDetail slug="rodent-control" />;

export default RodentControlPage;
